import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { translate } from 'react-polyglot'
import { submitProcessingAgency, showEditProcessingAgencyIntegrationModal } from '../../../actions/masters/masters'
import ProcessingAgencyIntegrationMasterModal from '../../../components/masters/processing/ProcessingAgencyIntegrationMasterModal'

export function mapStateToProps (state) {
  const processingAgencyModal = state.processingAgency.processingAgencyIntegrationModal
  return {
    showModal: processingAgencyModal.showModal,
    agency: processingAgencyModal.agency,
    combos: {
      UOTreeCombo: state.combos.UOTreeCombo
    }
  }
}

export function mapDispatchToProps (dispatch) {
  return {
    actions: bindActionCreators({
      submitProcessingAgency,
      showEditProcessingAgencyIntegrationModal
    }, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(translate()(ProcessingAgencyIntegrationMasterModal))
